import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=b972f1ae&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=js"
export * from "./Menu.vue?vue&type=script&lang=js"
import style0 from "./Menu.vue?vue&type=style&index=0&id=b972f1ae&prod&scoped=true&lang=css"
import style1 from "./Menu.vue?vue&type=style&index=1&id=b972f1ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b972f1ae",
  null
  
)

export default component.exports